import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  CustomerSearchCriteria,
  PageListBean,
  PostDatedCheckEntrySearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestPostDatedCheckEntryBeanRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CustomerService } from "../services/CustomerService.js";

export class PostDatedCheckLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, customerCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new PostDatedCheckEntrySearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new PostDatedCheckEntrySearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let postDatedCheckLookupCriteria = new PostDatedCheckEntrySearchCriteria();
    postDatedCheckLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = PostDatedCheckLookupCriteraHandler(
      companyCode,
      postDatedCheckLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      postDatedCheckLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Customer", "customerCode", 0, false); //2
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //2
    this.addColumnDefinition("Check#", "checkNumber", 0, false); //3
    this.addColumnDefinition("CheckDate", "checkDate", 0, false); //3
    this.addColumnDefinition("CheckAmount", "checkAmount", 0, false); //3
    this.addColumnDefinition("CurrencyCode", "currencyCode", 0, false); //3
    this.addColumnDefinition("Status", "status", 0, false); //3
  }
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.postDatedCheckEntryNumber)) {
      if (!isEmptyString(filterText)) {
        search.postDatedCheckEntryNumber = filterText;
        this.searchCriteria = new PostDatedCheckEntrySearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadPostDatedCheckList(lookup_dialog, pageNumber, search);
    }
  }
  loadPostDatedCheckList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new PostDatedCheckEntrySearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.postDatedCheckEntryNumber =
        searchCriteria.postDatedCheckEntryNumber;
      criteria.checkNumber = searchCriteria.checkNumber;
      criteria.createdDate = searchCriteria.createdDate;
      criteria.status = searchCriteria.status;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestPostDatedCheckEntryBeanRequest();
    requestInput.pageInput = pageList;
    requestInput.criteria = criteria;
    AccountReceivableService.getPostDatedCheckEntryPageList(
      requestInput,
      (response) =>
        this.loadPostDatedCheckListResponse(response, lookup_dialog),
      this.loadPostDatedCheckListError
    );
  };
  loadPostDatedCheckListResponse = (response, lookup_dialog) => {
    let postDatedCheckList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.postDatedCheckPageList) &&
      !isEmptyArray(response.data.postDatedCheckPageList.postDatedChecks)
    ) {
      postDatedCheckList = response.data.postDatedCheckPageList.postDatedChecks;
      totalCount = response.data.postDatedCheckPageList.totalCount;
      currentPageNumber = response.data.postDatedCheckPageList.currentPage;
      pageSize = response.data.postDatedCheckPageList.pageSize;
      postDatedCheckList.map((pl) => {
        pl.status = ModuleUtils.getPostDatedCheckEntryStatusCaption(pl.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = postDatedCheckList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadPostDatedCheckListError = (error) => {
    ShowError("Error : " + error);
  };
}
const PostDatedCheckLookupCriteraHandler = (
  companyCode,
  postDatedCheckLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PostDatedCheckEntrySearchCriteria(),
        customerPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
        is3PL: false,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({
        searchCriteria: new PostDatedCheckEntrySearchCriteria(),
      });
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };

    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      input.isLoadChildren = true;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let customerData = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      ShowError(error);
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <Container>
            {/* <Row>
              <Col sm={5}>
                <FormLabel>CheckEntry# stars twith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="postDatedCheckEntryNumber"
                  name="postDatedCheckEntryNumber"
                  onChange={this.onChange}
                  value={searchCriteria.postDatedCheckEntryNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CheckEntry# Containing </FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="postDatedCheckEntryNumber"
                  name="postDatedCheckEntryNumber"
                  onChange={this.onChange}
                  value={searchCriteria.postDatedCheckEntryNumber}
                />
              </Col>
            </Row> */}
            <Row>
              <Col sm={5}>
                <FormLabel>PostDatedCheckEntryNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="postDatedCheckEntryNumber"
                  name="postDatedCheckEntryNumber"
                  onChange={this.onChange}
                  value={searchCriteria.postDatedCheckEntryNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PostDatedCheckEntryNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="postDatedCheckEntryNumber"
                  name="postDatedCheckEntryNumber"
                  onChange={this.onChange}
                  value={searchCriteria.postDatedCheckEntryNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode</FormLabel>
              </Col>
              <Col sm={4}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Check#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="checkNumber"
                  name="checkNumber"
                  onChange={this.onChange}
                  value={searchCriteria.checkNumber}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"O"}>Open</option>
                  <option value={"A"}>Approved</option>
                  {/* //<option value={"A"}>Partially Finished</option> */}
                  <option value={"F"}>Finished</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  //tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
